import React, { Component } from "react";
import "./Header.scss";
import ColorHelper from "../../helper/ColorHelper";
import { ButtonIcon } from "global-components-library";

export default class Header extends Component {
  state = {
    headerStyle: null,
    headerLogoStyle: null,
  };

  componentDidMount() {
    let colorHelper = ColorHelper.getInstance();
    this.setState({
      headerStyle: colorHelper.getHeaderColorStyle(),
      headerLogoStyle: colorHelper.getHeaderLogoColorStyle(),
    });
  }

  minimize = () => {
    this.props.minimize();
  };

  closeConversation = () => {
    this.props.closeConversation();
  };

  render() {
    let { headerImgSrc, headerImgHeight, headerImgWidth, embedded } =
      window["boot"];
      const { header: headerLabels } = window["labels"];
    return (
      <div className="header">
        <div className="header-title">
          {headerLabels.title}
        </div>
        <div>
          <img
            src={headerImgSrc}
            alt="headerImgSrc"
            id="header-logo-img"
          />
        </div>
        <div className="icon-wrapper">
          {/* {!embedded && <ButtonIcon icon={"minus"} onClick={this.minimize} />} */}
          {this.props.isShowBtnClose && (
            <ButtonIcon icon={"close"} onClick={this.closeConversation} />
          )}
        </div>
      </div>
    );
  }
}
